
  import { Mixins, Component } from 'vue-mixin-decorator';
  import { namespace } from 'vuex-class';
  import { ISearchAdvert } from '@/interfaces/adverts';

  import { GoogleBanner } from '@onlinerby/vue-components';

  import SearchAdvertsListItem from '@/components/search/search-adverts-list-item.vue';
  import SearchAdvertsListItemStub from '@/components/search/search-adverts-list-item-stub.vue';
  import NoResults from '@/components/common/no-results.vue';
  import IsMobileMixin from '@/mixins/common/is-mobile';

  const searchStore = namespace('search');

  @Component({
    components: {
      GoogleBanner,
      SearchAdvertsListItem,
      SearchAdvertsListItemStub,
      NoResults,
    },
  })
  export default class SearchAdvertsList extends Mixins<IsMobileMixin>(
    IsMobileMixin,
  ) {
    private isAllLoaded = false;
    private stubCount = 0;

    @searchStore.State advertsList!: Array<ISearchAdvert>;
    @searchStore.State isLoading!: boolean;

    private created() {
      this.stubCount = this.isMobileSpecial ? 30 : 60;
    }

    public get adverts() {
      return this.advertsList;
    }
  }
